import { render } from "./outword.vue?vue&type=template&id=93b7fb7a"
import script from "./outword.vue?vue&type=script&lang=js"
export * from "./outword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__